export default __webpack_public_path__ + "72ab6dc84e6ab0311a6e167b5c4c487c.png";